import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Form, Spinner } from 'react-bootstrap';
import { IoAddOutline, IoDocumentTextOutline, IoSearch, IoSettingsOutline } from 'react-icons/io5';
import OutletHead from '../../../components/common/outlet-head';
import DataTable from '../../../components/datatables/parties';
import { query, collection, onSnapshot, orderBy } from "firebase/firestore";
import { db } from '../../../firebase';
import { useAuth } from '../../../context/AuthContext';

function Parties() {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);
  const [searchData, setSearchData] = useState({
    searchBy: 'aadharNumber',
    searchTerm: ''
  });

  function getParties() {
    const q = query(collection(db, "Businesses", bid, "Parties"), orderBy('partyName'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tempData = [];
      querySnapshot.forEach((doc) => {
        tempData.push({ id: doc.id, ...doc.data() });
      });
      setData(tempData);
      setIsLoading(false);
    }, (error) => {
      console.log(error.message);
    });

    return () => unsubscribe;
  }

  useEffect(() => {
    getParties();
  }, []);

  // const handleSearch = (event) => {
  //   event.preventDefault();
  //   let { searchBy, searchTerm } = searchData;
  //   if (searchBy && searchTerm) {
  //     const partyRef = collection(db, "Parties");
  //     const q = query(partyRef, where(searchBy, "in", [searchTerm]));
  //     const unsubscribe = onSnapshot(q, (querySnapshot) => {
  //       const tempData = [];
  //       querySnapshot.forEach((doc) => {
  //         tempData.push({ id: doc.id, ...doc.data() });
  //       });

  //       setData(tempData);
  //     }, (error) => {
  //       console.log(error.message);
  //     });

  //     return () => unsubscribe;
  //   } else {
  //     getParties();
  //   }
  // }

  return (

    <section className='section'>
      <OutletHead
        left={
          <h5 className='mb-0 fw-600'>Parties</h5>
        }
        right={
          <div className='d-flex align-items-center'>
            <Button
              variant="outline-primary"
              type="submit"
              className='py-2 px-4 me-3'
            >
              <IoDocumentTextOutline size={18} />
              <span className='ps-2'>Export</span>
            </Button>
            <Button
              variant="light"
              type="submit"
              className='border py-2 px-4'
            >
              <IoSettingsOutline size={20} />
              <span className='ps-2'>Settings</span>
            </Button>
          </div>
        }
      />
      <div className='p-3 border-top'>
        <div className='row'>
          <div className='col-lg-12'>
            {
              isLoading ?
                <div className='data-loading-container'>
                  <div className='loader'>
                    <Spinner variant="primary" style={{ width: 45, height: 45 }} />
                  </div>
                </div>
                :
                <div className='mb-5'>
                  <div className='pb-3'>
                    <Form onSubmit={null}>
                      <div className='row'>
                        <div className='col-8'>
                          <div className='row'>
                            <div className='col-lg-6 col-md-6 col-12'>
                              <div className='position-relative'>
                                <div className='position-absolute left-0 top-0 bottom-0 ps-3 d-flex align-items-center justify-content-center'>
                                  <IoSearch size={20} color={`var(--bs-placeholder)`} />
                                </div>
                                <Form.Control
                                  type="text"
                                  placeholder="Search your property"
                                  onChange={(e) => {
                                    if (e.target.value) {
                                      setSearchData({
                                        ...searchData,
                                        searchTerm: e.target.value
                                      });
                                    } else {
                                      getParties();
                                    }
                                  }}
                                  className='ps-5'
                                />
                              </div>
                            </div>
                            <div className='col-lg-4 col-md-4 col-12'>
                              <Form.Select
                                onChange={(e) => {
                                  if (e.target.value) {
                                    setSearchData({
                                      ...searchData,
                                      searchBy: e.target.value
                                    })
                                  } else {
                                    getParties();
                                  }
                                }}
                              >
                                <option value="aadhar_no">Location</option>
                                <option value="pan_no">Allahabad</option>
                                <option value="pan_no">Kaushambi</option>
                              </Form.Select>
                            </div>
                          </div>
                        </div>
                        <div className='col-4'>
                          <div className='d-flex align-items-center justify-content-end'>
                            <Link to="add">
                              <Button
                                variant="primary"
                                type="button"
                                className='py-2 px-3'
                              >
                                <IoAddOutline size={21} />
                                <span className='ps-2'>Add Party</span>
                              </Button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                  <DataTable
                    columns={['#', 'Party Name', "Father/Husband", '', 'Aadhar Number', 'Phone Number', 'City', 'State']}
                    data={data}
                  />
                </div>
            }
          </div>
        </div>
      </div>
    </section>
  );
}

export default Parties;
